export default "__VITE_ASSET__DcHpzOvE__"